import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ToUpdateButton from '../buttons/ToUpdateButton';

function TeacherMain() {
  const navigate = useNavigate();
  const [targetLearnerIdInput, setTargetLearnerIdInput] = useState('');
  const [targetLearnerIdError, setTargetLearnerIdError] = useState('');

  const isLearnerIdValid = targetLearnerIdInput && !isNaN(targetLearnerIdInput) && targetLearnerIdInput !== '0';

  const handleBack = () => {
    navigate('/');
  };

  return (
    <main className="container-center">
      <section className="card">
        <header className="card-header">
          <h1 className="text-2xl font-semibold">管理者メニュー</h1>
          <div className="mt-3 badge badge--blue">
            ユーザーID: 管理者
          </div>
        </header>
        <div className="form-group">
          <div>
            <label className="form-label">
              アップロード対象の学習者ユーザーID
            </label>
            <input
              type="number"
              value={targetLearnerIdInput}
              onChange={(e) => {
                setTargetLearnerIdInput(e.target.value);
                setTargetLearnerIdError('');
              }}
              placeholder="学習者のユーザーIDを入力"
              className="form-input"
              min="1"
            />
            {targetLearnerIdError && (
              <p className="text-error mt-2">{targetLearnerIdError}</p>
            )}
          </div>
          {!isLearnerIdValid && (
            <p className="text-warning">
              ⚠️ 学習者のユーザーIDを入力してから次に進んでください
            </p>
          )}
          <ToUpdateButton
            userId={targetLearnerIdInput || null}
            buttonText="デッサン画像のアップロード"
            disabled={!isLearnerIdValid}
          />
          <button onClick={handleBack} className="btn btn--gray w-full">
            ログアウト
          </button>
        </div>
      </section>
    </main>
  );
}

export default TeacherMain;